
/**
 * {@link https://github.com/my-color/front/issues/6682} のv1対応にあたり、
 * 文脈を問わずクレジットカードを登録・変更できる画面が急遽必要になった.
 *
 * LP用のクレジットカード登録・変更フォームができるまで、一旦クレジットカード変更画面を流用できるようにするため、
 * 完了後の画面遷移先およびテキスト表記を可変にするためのデータ型を定義している.
 *
 * 最終的には削除の可能性が高いので、積極的な再利用は基本的に避けること.
 */
export interface NextPageAfterCardRegistration {
  path: string
  label: string
}

export const defaultNextPage: NextPageAfterCardRegistration = {
  path: '/s/mypage',
  label: 'アカウントサービスTOPへ',
}
